export default "__VITE_ASSET__7Zp85FjM__"